
import { ref, defineEmit, onMounted, defineComponent } from 'vue'
export default defineComponent({
  name: 'Confirm',
  props: {
    title: String,
    message: String,
    confirm: Function,
  },
  setup(props, { emit }) {
    const visible = ref(false)
    const handleClose = () => {
      visible.value = false
    }
    const handleConfirm = () => {
      emit('confirm')
      handleClose()
    }
    return{
      visible,
      handleClose,
      handleConfirm,
      props,
    }
  }
})

